export const PLATINUM_POWER_BI = {
  sdkUrl: 'https://cdn.jsdelivr.net/npm/powerbi-client@2.23.1/dist/powerbi.js',
  tenantId: '8d619df9-6a12-461c-8975-9b246bc059f6',
  reportId: '4711fafa-eab3-47cd-8bdd-e29bcb3bd8b1',
  groupId: 'e56df327-12b5-4de6-bfb6-8936d35ea60d',
  baseEmbedUrl:
    'https://app.powerbi.com/reportEmbed?reportId=4711fafa-eab3-47cd-8bdd-e29bcb3bd8b1&groupId=e56df327-12b5-4de6-bfb6-8936d35ea60d&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVBRS1OT1JUSC1BLVBSSU1BUlktcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQiLCJlbWJlZEZlYXR1cmVzIjp7InVzYWdlTWV0cmljc1ZOZXh0Ijp0cnVlfX0%3d',
  filterTable: 'dc_Member360_MemberDetails',
  filterColumn: 'Member_ID',
} as const;

export function buildPlatinumReportEmbedUrl(memberId: string): string {
  const filter = `${PLATINUM_POWER_BI.filterTable}/${PLATINUM_POWER_BI.filterColumn} eq '${String(memberId ?? '').trim()}'`;
  return `${PLATINUM_POWER_BI.baseEmbedUrl}&filter=${encodeURIComponent(filter)}`;
}
